import { useEffect, useState } from "react";
import { userAPI } from "../services/api";

const useLeadStage = () => {
  const [leadStage, setLeadStage] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [isReloan, setIsReloan] = useState(false);
  const [isAddFeedback, setIsAddFeedback] = useState(false);
  const [isLoadingStage, setIsLoadingStage] = useState(true);
  const [errorStage, setErrorStage] = useState(null);
  const [isSurvey, setIsSurvey] = useState(false);
  const [isSignCompleted, setIsSignCompleted] = useState(false);
  const [appliedCouponCodeBackend, setAppliedCouponCodeBackend] = useState("");
  const [hasAppliedCoupon, setHasAppliedCoupon] = useState(false);
  const [discountReceived, setDiscountReceived] = useState(0);

  const [isLoyaltyAddressAdded, setIsLoyaltyAddressAdded] = useState(false);
  const [isLoyaltPointInitiated, setIsLoyaltPointInitiated] = useState(false);
  const [isDisbursed, setIsDisbursed] = useState(false);

  useEffect(() => {
    const fetchJourneyStep = async () => {
      setIsLoadingStage(true);
      try {
        const data = await userAPI.getJourney();
        setIsActive(data?.journey?.is_active || false);
        setIsClosed(data?.journey?.is_closed || false);
        setIsReloan(data?.journey?.is_reloan_case || false);
        setLeadStage(data?.journey?.lead_stage || null);
        setIsAddFeedback(data?.journey?.is_add_feedback || false);
        setIsSurvey(data?.journey?.is_survey_added || false);
        setIsSignCompleted(data?.journey?.is_eSigned || false);

        setHasAppliedCoupon(data?.journey?.has_applied_coupon || false);
        setDiscountReceived(data?.journey?.discount_received || 0);
        setAppliedCouponCodeBackend(data?.journey?.applied_coupon_code || "");
        setIsLoyaltyAddressAdded(data?.journey?.is_loyalty_address_added || false);
        setIsLoyaltPointInitiated(data?.journey?.is_loyalty_point_initiated || false);
        setIsDisbursed(data?.journey?.is_disbursed || false);
      } catch (err) {
        // console.error("Error fetching journey step:", err);
        setErrorStage("Failed to load journey step");
      } finally {
        setIsLoadingStage(false);
      }
    };

    fetchJourneyStep();
  }, []);

  return {
    leadStage,
    isLoadingStage,
    errorStage,
    isActive,
    isClosed,
    isReloan,
    isAddFeedback,
    isSurvey,
    isSignCompleted,
    appliedCouponCodeBackend,
    hasAppliedCoupon,
    discountReceived,
    isLoyaltyAddressAdded,
    isLoyaltPointInitiated,
    isDisbursed,
  };
};

export default useLeadStage;
